import React, {useEffect, useState} from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"

import { useFirebase } from "@meddbriefer/mdb-firebase"
import {MDBNavBar} from "@meddbriefer/mdb-ui";

import {useObserverContext} from "../contexts/ObserverContext"

// need a better way/place to manage feature-flag controling which assigment lists to use

export default function ScenarioList(props) {
    const {db} = useFirebase()
    const {classCode}  = useObserverContext()
    const [scenarios, setScenarios] = useState([])
    const [orderRequired, setOrderRequired] = useState(false)

    useEffect(() => {
        console.log("class_code", classCode)
        db.collection("class-codes")
            .where("name", "==", classCode)
            .limit(1)
            .get()
            .then(snapshot => {
                if( snapshot.size === 1) {
                    const doc = snapshot.docs[0]
                    const tmp = doc.data()
                    console.log(tmp)
                    setOrderRequired(tmp.orderRequired)
                    let assignments = tmp.assignments
                    console.log(assignments)
                    setScenarios(assignments)
                }
            })
            .catch(error => console.log(error))
        }, [db, classCode]
    )

    return (
        <>
            <MDBNavBar title="Scenario List" />
            <Container>
                <Row>
                    <Col sm="3"></Col>
                    <Col sm="6">
                        <h2>Your Assigned Scenarios:</h2>
                        <ul>
                            {scenarios.map((scen) => (
                                <li key={scen.publishedScenarioID}>
                                    <Link className="h3" to={`/scenario/${scen.publishedScenarioID}`}> {scen.name}</Link>
                                </li>
                            ))}
                        </ul>
                    </Col>
                    <Col sm="3"></Col>
                </Row>
            </Container>
        </>
    )
}
